import { Badge } from '@chakra-ui/react'

const Container = ({ total }: { total: number }) => {
    const size = total < 10 ? 'sm' : total < 99 ? 'md' : 'lg'
    const _total = total < 100 ? total : '99+'

    if (total === 0) return
    return (
        <Badge right={size !== 'sm' ? '-5px' : 0} size={size} justifyContent="center" letterSpacing="initial">
            {_total}
        </Badge>
    )
}

export default Container
